/*
 * IMPORTS
 */
import React from 'react' // NPM: React.js library.
import Head from 'next/head' // NPM: Next.js header utility.
import Dynamic from 'next/dynamic' // NPM: Next.js dynamic component utility.
import { useInView } from 'react-intersection-observer' // NPM: React intersection observer.


/*
 * COMPONENTS
 */
const Navbar = Dynamic(() => import('~packages/common/container/Navbar'), { 'loading': Object.Next.Dynamic.Loading })
const Footer = Dynamic(() => import('~packages/common/container/Footer'), { 'loading': Object.Next.Dynamic.Loading })
const Banner = Dynamic(() => import('~packages/common/container/Banner'), { 'loading': Object.Next.Dynamic.Loading })
const MvpInBackyard = Dynamic(() => import('~packages/common/container/MvpInBackyard'), { 'loading': Object.Next.Dynamic.Loading })
const OurCommitment = Dynamic(() => import('~packages/common/container/OurCommitment'), { 'loading': Object.Next.Dynamic.Loading })
const SolutionToProblem = Dynamic(() => import('~packages/common/container/SolutionToProblem'), { 'loading': Object.Next.Dynamic.Loading })
const GlobalFooter = Dynamic(() => import('~packages/common/container/GlobalFooter'), { 'loading': Object.Next.Dynamic.Loading })
const HowAiHelp = Dynamic(() => import('~packages/common/container/HowAiHelp'), { 'loading': Object.Next.Dynamic.Loading })
const TimelineContentOnSlidingTray = Dynamic(() => import('~packages/common/container/TimelineContentOnSlidingTray'), { 'loading': Object.Next.Dynamic.Loading })
const Discount = Dynamic(() => import('~packages/common/container/Discount'), { 'loading': Object.Next.Dynamic.Loading })
const BraveIdeas = Dynamic(() => import('~packages/common/container/BraveIdeas'), { 'loading': Object.Next.Dynamic.Loading })


/*
 * OBJECTS
 */
const Index = ({ container = { 'overflowX': 'hidden' } }) => {
  // Hook assignment.
  const _isHeroBannerVisible = useInView({ 'threshold': 0 })
  const _isHowItWorksVisible = useInView({ 'threshold': 0 })
  const _isAboutToolWithFlowerVisible = useInView({ 'threshold': 0 })

  // Event handler.
  React.useEffect(() => {
console.log(window.gsap, window.ScrollSmoother)
    // Check if ScrollSmoother is available
    if (typeof window !== 'undefined' && window.ScrollSmoother) {
      const smoother = window.ScrollSmoother.create({
        smooth: 1,  // Set the smoothness
        effects: true // Enables effects on scroll
      });

      // Clean up on unmount
      return () => {
        if (smoother) {
          smoother.kill();
        }
      };
    }
  }, [window]);

  // Return component.
  return (
    <section style={container} className='smoothWrapper'>
      <Head>
        <title>Rootandleaves | A Leader in Software Development</title>
        <meta name='Description' content='Rootandleaves is a leader in software development, with a focus on innovative and beautiful solutions in JavaScript, Python and Rust languages. We provide IT support and digital marketing services to businesses in Bangalore and Gurgaon.' />
      </Head>
      <section className='smoothContent'>
        <section ref={_isHeroBannerVisible.ref} className='gradientWrapper topLeft round'>
          <canvas className='gradient gradient1 color theme' />
          <div className='overlay occlusion' />
          <Navbar />
          <Banner inView={_isHeroBannerVisible} />
        </section>
        <MvpInBackyard />
        <BraveIdeas />
        <section ref={_isAboutToolWithFlowerVisible.ref} className='gradientWrapper topRight round'>
          <canvas className='gradient gradient2 color theme' />
          <div className='overlay occlusion' />
          <SolutionToProblem inView={_isAboutToolWithFlowerVisible.inView} />
        </section>
        <section style={{ 'position': 'relative' }}>
          <OurCommitment />
          <TimelineContentOnSlidingTray>
            SMSFLASH.IN&nbsp;SHUCAEFILMS.COM&nbsp;JUSPLAYTOYS.COM&nbsp;HONORVETS.COM&nbsp;GARBIT.COM
          </TimelineContentOnSlidingTray>
          <section ref={_isHowItWorksVisible.ref} className='gradientWrapper topLeft round'>
            <canvas className='gradient gradient3 color theme switch' />
            <div className='overlay occlusion' />
            <HowAiHelp />
          </section>
        </section>
        <Discount />
        <Footer />
        <GlobalFooter />
      </section>
    </section>
  )
}


/*
 * EXPORTS
 */
export default Index
